import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../../utils/mq';
import { Cta } from '../cta';

const EmbedAffilizzCta = styled.div`
  display: flex;
  justify-content: space-around;
`;

const AffilizzBtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
`;

const AffilizzCtaBtn = styled(Cta)`
  margin: var(--spacer-s-fluid) 0 var(--spacer-fluid);
  padding: 10px 13px;
  line-height: 1.62;
  width: initial;

  && {
    color: var(--theme-palette-white);
    text-decoration: none;
  }

  background: var(--theme-palette-red);
  border: solid 2px var(--theme-palette-red);
  border-radius: 6px;
  font-weight: bold;
  position: relative;
  text-align: center;
  transition: background-color 0.3s, border-color 0.3s;

  &:hover {
    background: var(--theme-palette-dark-red);
    border: solid 2px var(--theme-palette-dark-red);
  }

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      padding: 8px 10px;
      font-size: 16px;
    `,
  )}
`;

const AffilizzPromoCode = styled.div`
  top: -3em;
  position: relative;
  background-color: #526c8a;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 40px;
  color: var(--theme-palette-white);
  padding: 0px 10px;
  transition: background-color 0.3s;

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      top: -1.8em;
      padding: 1px 10px;
      font-size: 16px;
    `,
  )}

  :hover {
    background-color: #ff9900;
  }
`;

interface AffilizzCtaProps {
  url?: string;
  buttonLabel?: string;
  promoCode?: string;
  as?: any;
  onClick: any;
}

const AffilizzCta = ({ url, buttonLabel, promoCode, as, onClick }: React.PropsWithChildren<AffilizzCtaProps>) => {
  return (
    <EmbedAffilizzCta>
      <AffilizzBtnContainer>
        <AffilizzCtaBtn as={as} data-testid="cta-button" href={url} onClick={onClick}>
          {buttonLabel}
        </AffilizzCtaBtn>
        {promoCode && <AffilizzPromoCode>{promoCode}</AffilizzPromoCode>}
      </AffilizzBtnContainer>
    </EmbedAffilizzCta>
  );
};

export default AffilizzCta;
